import type {
  Product,
  TranslationKey,
} from "../../../../constants/modelCompareData/types";
import type { StoreId } from "@ubnt/store.core/lib/types";

export const parseFootnotes = (
  footnotes: Product["footnotes"],
  storeId: StoreId,
): TranslationKey[] =>
  footnotes
    ?.map((footnote) =>
      typeof footnote === "string" ? footnote : footnote(storeId),
    )
    .filter((f): f is TranslationKey => typeof f === "string") || [];
